import { LatestSearchCookieRegistry } from '@/constants/cookieRegistry'
import { isRegionSpecified } from '@/domain/location/isRegionSpecified'
import { type Locale } from '@/generated'
import { type GlobalLocation } from '@/lib/apollo/locationCache'
import {
  type LatestSearchCookie,
  decodeLocationCookieAddress,
} from '@/utils/cookies/latestSearchCookie'

import { getLocationName } from './getLocationName'

export const convertCookieToGlobalLocation = async (
  latestSearch?: LatestSearchCookie
): Promise<GlobalLocation> => {
  const cookieLocationId = latestSearch?.[LatestSearchCookieRegistry.LOCATION_ID]
  const cookieLatitude = latestSearch?.[LatestSearchCookieRegistry.LATITUDE]
  const cookieLongitude = latestSearch?.[LatestSearchCookieRegistry.LONGITUDE]
  const cookieRadius = latestSearch?.[LatestSearchCookieRegistry.RADIUS]
  const cookieAddress = latestSearch?.[LatestSearchCookieRegistry.ADDRESS]

  const locationId = cookieLocationId ? parseInt(cookieLocationId) : undefined

  /** Has exact location if there is not a lat and log */
  const isRegion = isRegionSpecified(cookieLatitude, cookieLongitude)

  /** Get location name based on Id if any*/
  let locationName: Locale = { en_CA: '', fr_CA: '' }
  if (locationId !== undefined && locationId !== null) {
    locationName = await getLocationName(locationId)
  }

  const location: GlobalLocation = {
    isRegion,
    id: locationId,
    name: locationName,
  }

  /**
   * Prevent returning "undefined" values to safe guard server-side calls
   * */
  if (cookieLatitude) location.latitude = parseFloat(cookieLatitude)
  if (cookieLongitude) location.longitude = parseFloat(cookieLongitude)
  if (cookieRadius) location.radius = parseInt(cookieRadius)
  if (cookieAddress) location.streetAddress = decodeLocationCookieAddress(cookieAddress)

  return location
}
